export default [
  {
    name: "A: Bolter & CC weapon (same profiles)",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 4,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 4,
    computed_wounds: 4,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "94972265-3100-400b-b18b-2319a0f9ba90",
        modelTypeName: null,
        unitId: "368bc795-2444-4cfa-a289-caa530fdbb32",
      },
    ],
    units: [
      {
        id: "368bc795-2444-4cfa-a289-caa530fdbb32",
        leader: false,
        name: "A: Bolter & CC weapon (same profiles) > Unit 1",
        abilities: [],
        points: null,
        model_types: [
          {
            modelCount: 4,
            save: 4,
            toughness: 4,
            weapons: [
              {
                name: "Bolter",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 10,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "61d4d2d1-85ac-4635-9560-64f9ed6e6d0c",
                bs: 3,
                ws: null,
                nameUnique: "Bolter",
                abilities: [],
              },
              {
                name: "Close combat weapon",
                type: "Melee",
                attacks: 10,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "cd5f7b35-a61a-49bf-ad5c-142e6bbe7a8b",
                countPerUnit: 1,
                bs: null,
                ws: 3,
                nameUnique: "Close combat weapon",
                abilities: [],
              },
            ],
            wounds: 4,
            id: "94972265-3100-400b-b18b-2319a0f9ba90",
            name: "A: Bolter & CC weapon (same profiles) > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["cd5f7b35-a61a-49bf-ad5c-142e6bbe7a8b"],
    weapons_selected_ranged: ["61d4d2d1-85ac-4635-9560-64f9ed6e6d0c"],
  },
  {
    name: "Boys led by Medic",
    computed_keywords: ["CHARACTER", "INFANTRY"],
    computed_leaders: [
      {
        unitId: 1,
        unitName: "Medic",
      },
    ],
    computed_model_count: 11,
    computed_points: 155,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 5,
    computed_wounds: 14,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "37066bdb-8473-4eaa-86bf-cdd1b7e7c271",
        modelTypeName: "Boys",
        unitId: "dba5df48-a22d-45ab-8502-73668049bf4d",
      },
      {
        modelTypeId: "2fa00b37-e286-45e0-9b5e-4c14d1764a1a",
        modelTypeName: "Boss",
        unitId: "dba5df48-a22d-45ab-8502-73668049bf4d",
      },
      {
        modelTypeId: "228b1876-489c-4aa0-9a79-8389ef537674",
        modelTypeName: "Medic",
        unitId: "0ca77d8b-f305-41a6-802f-16c0c2ae9c76",
      },
    ],
    units: [
      {
        abilities: [],
        id: "0ca77d8b-f305-41a6-802f-16c0c2ae9c76",
        leader: true,
        name: "Medic",
        points: 70,
        model_types: [
          {
            id: "228b1876-489c-4aa0-9a79-8389ef537674",
            ignore: null,
            invuln: null,
            keywords: ["CHARACTER", "INFANTRY"],
            modelCount: 1,
            name: "Medic",
            save: 5,
            toughness: 5,
            weapons: [
              {
                name: "Syringe",
                countPerUnit: 1,
                type: "Melee",
                attacks: 1,
                ws: 3,
                strength: 2,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Anti-INFANTRY 4+",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                        data: {
                          keywords: ["INFANTRY"],
                        },
                        description: "Require one or more keywords.",
                        preselected: false,
                      },
                      {
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        description:
                          "Require a specific roll value in the attack sequence.",
                        preselected: false,
                      },
                    ],
                    description:
                      "Wound roll of 4+ (unmodified) : critical wound (INFANTRY only)",
                    effect: {
                      text: "Override requirements",
                      type: "overrideReqs",
                      data: {
                        crit: true,
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "94599f88-0d7c-4093-9fd9-cefd6d41153e",
                    sharedWithAllUnits: false,
                  },
                  {
                    aliases: [],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Critical hit/wound",
                        type: "crit",
                        data: {
                          crit: {
                            title: "Critical wound",
                            key: "woundRoll",
                          },
                        },
                        description: 'Require a hit or wound to be "critical".',
                        preselected: false,
                        scope: ["global", "profile", "weapon"],
                      },
                      {
                        text: "Keywords (excludes)",
                        type: "keywordsExcludes",
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        description: "Exclude one or more keywords.",
                        preselected: false,
                        scope: ["global", "profile", "weapon"],
                      },
                    ],
                    description:
                      "Critical wound : D6 mortal wounds (excludes VEHICLE)",
                    effect: {
                      text: "Mortal wounds",
                      type: "mortalWounds",
                      data: {
                        attackSequenceEnds: false,
                        cap: null,
                        matchWeaponDamage: false,
                        mortalWoundsValue: "D6",
                      },
                    },
                    id: "0d59ba41-696a-4468-a6f6-d3d55e13529b",
                    scope: ["weapon"],
                    sharedWithAllUnits: false,
                  },
                ],
                id: "2ff8a815-7595-4430-a0ec-0411770d1ded",
                nameUnique: "Syringe",
              },
              {
                name: "Power claw",
                countPerUnit: 1,
                type: "Melee",
                attacks: 3,
                ws: 4,
                strength: 9,
                ap: -2,
                damage: 2,
                id: "0c6178c7-1077-41cd-9dd0-1137d5eb1585",
                nameUnique: "Power claw",
                abilities: [],
              },
            ],
            wounds: 3,
          },
        ],
        abilities_selected: [],
      },
      {
        abilities: [],
        id: "dba5df48-a22d-45ab-8502-73668049bf4d",
        leader: false,
        name: "Boys",
        points: 85,
        model_types: [
          {
            id: "37066bdb-8473-4eaa-86bf-cdd1b7e7c271",
            ignore: null,
            invuln: null,
            keywords: ["INFANTRY"],
            modelCount: 9,
            name: "Boys",
            save: 5,
            toughness: 5,
            weapons: [
              {
                name: "Chopper",
                countPerUnit: 9,
                type: "Melee",
                attacks: 3,
                ws: 3,
                strength: 4,
                ap: -1,
                damage: 1,
                id: "39afb789-7da7-4115-a1c1-400de2a913ac",
                nameUnique: "Chopper",
                abilities: [],
              },
              {
                name: "Slugger",
                countPerUnit: 9,
                type: "Ranged",
                attacks: 1,
                bs: 5,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "1774e0b8-4024-4a7a-8042-7bda3fa064eb",
                nameUnique: "Slugger (Boys)",
                abilities: [],
              },
            ],
            wounds: 1,
          },
          {
            id: "2fa00b37-e286-45e0-9b5e-4c14d1764a1a",
            ignore: null,
            invuln: null,
            keywords: ["INFANTRY"],
            modelCount: 1,
            name: "Boss",
            save: 5,
            toughness: 5,
            weapons: [
              {
                name: "Big chopper",
                countPerUnit: 1,
                type: "Melee",
                attacks: 3,
                ws: 3,
                strength: 7,
                ap: -1,
                damage: 2,
                id: "ce338e68-16de-4f1c-92aa-b6a5404ff535",
                nameUnique: "Big chopper",
                abilities: [],
              },
              {
                name: "Slugger",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 1,
                bs: 5,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "d5f77a5c-b172-4e1d-99c1-02dca1c583b8",
                nameUnique: "Slugger (Boss)",
                abilities: [],
              },
            ],
            wounds: 2,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "2ff8a815-7595-4430-a0ec-0411770d1ded",
      "0c6178c7-1077-41cd-9dd0-1137d5eb1585",
      "39afb789-7da7-4115-a1c1-400de2a913ac",
      "ce338e68-16de-4f1c-92aa-b6a5404ff535",
    ],
    weapons_selected_ranged: [
      "1774e0b8-4024-4a7a-8042-7bda3fa064eb",
      "d5f77a5c-b172-4e1d-99c1-02dca1c583b8",
    ],
  },
  {
    name: "Avengers",
    computed_keywords: ["INFANTRY"],
    computed_leaders: [],
    computed_model_count: 5,
    computed_points: 0,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 3,
    computed_wounds: 6,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "6c36ad81-5fb1-443b-9bf5-abd32385c15e",
        modelTypeName: "Avenger",
        unitId: "12af5062-9133-47d7-ac0c-4faa24919985",
      },
      {
        modelTypeId: "c4bee2e0-4084-4658-9dc9-dc4a08a60a6c",
        modelTypeName: "Avenger Exarch",
        unitId: "12af5062-9133-47d7-ac0c-4faa24919985",
      },
    ],
    units: [
      {
        abilities: [],
        id: "12af5062-9133-47d7-ac0c-4faa24919985",
        leader: false,
        name: "Avengers > Unit 1",
        points: null,
        model_types: [
          {
            id: "6c36ad81-5fb1-443b-9bf5-abd32385c15e",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY"],
            modelCount: 4,
            name: "Avenger",
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Close combat weapon",
                countPerUnit: 4,
                type: "Melee",
                attacks: 2,
                ws: 3,
                strength: 3,
                ap: 0,
                damage: 1,
                id: "df3773f5-9919-4e1d-8a3e-edbcf99ab3d0",
                nameUnique: "Close combat weapon",
                abilities: [],
              },
              {
                name: "Catapult",
                countPerUnit: 4,
                type: "Ranged",
                attacks: 3,
                bs: 3,
                strength: 4,
                ap: -1,
                damage: 1,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Lethal hits",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Critical hit/wound",
                        type: "crit",
                        data: {
                          crit: {
                            title: "Critical hit",
                            key: "hitRoll",
                          },
                        },
                        description: 'Require a hit or wound to be "critical".',
                        preselected: false,
                      },
                    ],
                    description: "Critical hit : always wound",
                    effect: {
                      text: "Override requirements",
                      type: "overrideReqs",
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "3063f704-9e59-41f1-889c-d37d5c094c9a",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "726b1abb-5e93-49db-acbe-a2e8e5748405",
                nameUnique: "Catapult",
              },
            ],
            wounds: 1,
          },
          {
            id: "c4bee2e0-4084-4658-9dc9-dc4a08a60a6c",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY"],
            modelCount: 1,
            name: "Avenger Exarch",
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Glaive",
                countPerUnit: 1,
                type: "Melee",
                attacks: 3,
                ws: 3,
                strength: 5,
                ap: -2,
                damage: 1,
                id: "278992aa-b443-4174-94c7-cf6e414f7904",
                nameUnique: "Glaive",
                abilities: [],
              },
              {
                name: "Pistol",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 1,
                bs: 3,
                strength: 4,
                ap: -1,
                damage: 1,
                id: "ff37599c-d17c-4210-9652-ff001624ae56",
                nameUnique: "Pistol",
                abilities: [],
              },
            ],
            wounds: 2,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [
      "df3773f5-9919-4e1d-8a3e-edbcf99ab3d0",
      "278992aa-b443-4174-94c7-cf6e414f7904",
    ],
    weapons_selected_ranged: [
      "726b1abb-5e93-49db-acbe-a2e8e5748405",
      "ff37599c-d17c-4210-9652-ff001624ae56",
    ],
  },
  {
    name: "Vanguard led by Manipulus",
    computed_keywords: ["CHARACTER", "INFANTRY"],
    computed_leaders: [
      {
        unitId: 2,
        unitName: "Manipulus",
      },
    ],
    computed_model_count: 11,
    computed_points: 0,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 3,
    computed_wounds: 14,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "945ab9dc-c1db-41ed-8bbe-30d7526855b5",
        modelTypeName: "Manipulus",
        unitId: "3f145868-7b85-450a-9b5a-912229a1f171",
      },
      {
        modelTypeId: "9aa2ab9d-4694-47e5-8f45-c06334714429",
        modelTypeName: "Skitarii Vanguard",
        unitId: "8a79c0e1-a87a-4f91-9220-60093ff6f1a5",
      },
      {
        modelTypeId: "4c4c2a33-1074-4a22-8127-edd6d45fdd68",
        modelTypeName: "Skitarii Vanguard Alpha",
        unitId: "8a79c0e1-a87a-4f91-9220-60093ff6f1a5",
      },
    ],
    units: [
      {
        abilities: [
          {
            aliases: [
              {
                name: "Ignores cover",
                type: "reserved",
              },
            ],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
            ],
            description: "Ignore cover (if attacker)",
            effect: {
              text: "Special",
              type: "special",
              data: {
                option: {
                  title: "Ignore cover",
                  key: "ignoreCover",
                },
              },
            },
            scope: ["profile"],
            sharedWithAllUnits: true,
            id: "82b53305-eb9e-4181-9f3b-73ba36f7b715",
          },
        ],
        id: "8a79c0e1-a87a-4f91-9220-60093ff6f1a5",
        leader: false,
        name: "Skitarii Vanguard",
        points: null,
        model_types: [
          {
            id: "9aa2ab9d-4694-47e5-8f45-c06334714429",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY"],
            modelCount: 9,
            name: "Skitarii Vanguard",
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Radium carbine",
                countPerUnit: 9,
                type: "Ranged",
                attacks: 3,
                bs: 4,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Anti-INFANTRY 4+",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                        data: {
                          keywords: ["INFANTRY"],
                        },
                        description: "Require one or more keywords.",
                        preselected: false,
                      },
                      {
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        description:
                          "Require a specific roll value in the attack sequence.",
                        preselected: false,
                      },
                    ],
                    description:
                      "Wound roll of 4+ (unmodified) : critical wound (INFANTRY only)",
                    effect: {
                      text: "Override requirements",
                      type: "overrideReqs",
                      data: {
                        crit: true,
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "9ae1375f-e426-4e6a-8fd1-a7859ca5c429",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "5feef58f-5840-4e44-8f06-ef0c9bf72243",
                nameUnique: "Radium carbine",
              },
              {
                name: "Close combat weapon",
                countPerUnit: 9,
                type: "Melee",
                attacks: 1,
                ws: 4,
                strength: 3,
                ap: 0,
                damage: 1,
                id: "0a33e360-101d-43d4-be1d-d86c5c2ff927",
                nameUnique: "Close combat weapon",
                abilities: [],
              },
            ],
            wounds: 1,
          },
          {
            id: "4c4c2a33-1074-4a22-8127-edd6d45fdd68",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY"],
            modelCount: 1,
            name: "Skitarii Vanguard Alpha",
            save: 4,
            toughness: 3,
            weapons: [
              {
                name: "Alpha combat weapon",
                countPerUnit: 1,
                type: "Melee",
                attacks: 2,
                ws: 4,
                strength: 5,
                ap: -1,
                damage: 1,
                id: "fa6c28bb-468e-4024-be71-ef2eef555077",
                nameUnique: "Alpha combat weapon",
                abilities: [],
              },
              {
                name: "Radium carbine",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 3,
                bs: 4,
                strength: 3,
                ap: 0,
                damage: 1,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Anti-INFANTRY 4+",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                        data: {
                          keywords: ["INFANTRY"],
                        },
                        description: "Require one or more keywords.",
                        preselected: false,
                      },
                      {
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        description:
                          "Require a specific roll value in the attack sequence.",
                        preselected: false,
                      },
                    ],
                    description:
                      "Wound roll of 4+ (unmodified) : critical wound (INFANTRY only)",
                    effect: {
                      text: "Override requirements",
                      type: "overrideReqs",
                      data: {
                        crit: true,
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "4b6f0109-fef3-4ede-a57c-bf68f110b3b1",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "4da33d80-6409-4491-8f8c-4f5c6ad9ffdb",
                nameUnique: "Radium carbine",
              },
            ],
            wounds: 1,
          },
        ],
        abilities_selected: ["82b53305-eb9e-4181-9f3b-73ba36f7b715"],
      },
      {
        abilities: [
          {
            aliases: [
              {
                name: "Lethal hits",
                type: "reserved",
              },
            ],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
              {
                text: "Critical hit/wound",
                type: "crit",
                data: {
                  crit: {
                    title: "Critical hit",
                    key: "hitRoll",
                  },
                },
                description: 'Require a hit or wound to be "critical".',
                preselected: false,
              },
            ],
            description: "Critical hit : always wound (if attacker)",
            effect: {
              text: "Override requirements",
              type: "overrideReqs",
              data: {
                crit: false,
                irrespective: false,
                outcome: {
                  title: "Wound",
                  key: "wound",
                },
                type: {
                  title: "Always",
                  key: "always",
                },
              },
            },
            scope: ["profile"],
            id: "c973de36-82a0-47ca-b7cb-a06168f6fdee",
            sharedWithAllUnits: false,
          },
          {
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: true,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            description: "4++ invuln save",
            aliases: [],
            effect: {
              data: {
                invulnValue: "4",
              },
              text: "Invulnerable save",
              type: "invulnSave",
            },
            scope: ["profile"],
            aliasActive: true,
            id: "7e147699-686e-4018-96da-0ac7467da863",
            sharedWithAllUnits: false,
          },
        ],
        id: "3f145868-7b85-450a-9b5a-912229a1f171",
        leader: true,
        name: "Manipulus",
        points: null,
        model_types: [
          {
            id: "945ab9dc-c1db-41ed-8bbe-30d7526855b5",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY", "CHARACTER"],
            modelCount: 1,
            name: "Manipulus",
            save: 2,
            toughness: 4,
            weapons: [
              {
                name: "Omnissian staff",
                countPerUnit: 1,
                type: "Melee",
                attacks: 4,
                ws: 3,
                strength: 6,
                ap: -1,
                damage: 2,
                id: "085b3ab7-7d41-4a24-afda-8533eb5588c9",
                nameUnique: "Omnissian staff",
                abilities: [],
              },
              {
                name: "Transonic cannon",
                countPerUnit: 1,
                type: "Ranged",
                attacks: "D6",
                strength: 4,
                ap: 0,
                damage: 2,
                abilities: [
                  {
                    description: "Always hit",
                    scope: ["weapon"],
                    conditions: [],
                    aliases: [
                      {
                        name: "Torrent",
                        type: "reserved",
                      },
                    ],
                    effect: {
                      data: {
                        irrespective: false,
                        outcome: {
                          title: "Hit",
                          key: "hit",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                        crit: false,
                      },
                      text: "Override requirements",
                      type: "overrideReqs",
                    },
                    aliasActive: true,
                    id: "a2e1eb1b-dc2c-437e-9ada-cb3916973bc0",
                    sharedWithAllUnits: false,
                  },
                  {
                    aliases: [
                      {
                        name: "Devastating wounds",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Critical hit/wound",
                        type: "crit",
                        data: {
                          crit: {
                            title: "Critical wound",
                            key: "woundRoll",
                          },
                        },
                        description: 'Require a hit or wound to be "critical".',
                        preselected: false,
                        scope: ["global", "profile", "weapon"],
                      },
                    ],
                    description: "Critical wound : disable save (inc. invuln)",
                    effect: {
                      text: "Disable mechanic",
                      type: "disableAbility",
                      data: {
                        option: {
                          title: "Disable save (inc. invuln)",
                          key: "disableSave",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "a7c424c5-49f1-43fb-b82b-a5896d2f7b4c",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "63107cdd-ae66-4040-85fc-144826ae1cb4",
                nameUnique: "Transonic cannon",
              },
            ],
            wounds: 4,
          },
        ],
        abilities_selected: ["c973de36-82a0-47ca-b7cb-a06168f6fdee"],
      },
    ],
    weapons_selected_melee: [
      "0a33e360-101d-43d4-be1d-d86c5c2ff927",
      "fa6c28bb-468e-4024-be71-ef2eef555077",
      "085b3ab7-7d41-4a24-afda-8533eb5588c9",
    ],
    weapons_selected_ranged: [
      "5feef58f-5840-4e44-8f06-ef0c9bf72243",
      "4da33d80-6409-4491-8f8c-4f5c6ad9ffdb",
      "63107cdd-ae66-4040-85fc-144826ae1cb4",
    ],
  },
  {
    name: "Breachers led by Dominus",
    computed_keywords: ["CHARACTER", "INFANTRY"],
    computed_leaders: [
      {
        unitId: 2,
        unitName: "Dominus",
      },
    ],
    computed_model_count: 4,
    computed_points: 0,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 7,
    computed_wounds: 13,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "a9b5bf92-8396-419d-a9ba-0a72f111a31d",
        modelTypeName: "Breacher",
        unitId: "fb3795c1-7f0c-40a9-a1dc-26af2535799f",
      },
      {
        modelTypeId: "ed84838f-defd-4338-b67d-4b8fd57bf261",
        modelTypeName: "Dominus",
        unitId: "7345281b-cec3-478a-9ac6-dd6d8a602f52",
      },
    ],
    units: [
      {
        abilities: [
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "Re-roll all hit roll results of 1 (if attacker)",
            effect: {
              text: "Re-roll",
              type: "reRoll",
              data: {
                application: {
                  title: "Hit roll",
                  key: "hitRoll",
                },
                limit: {
                  title: "No limit",
                  key: "none",
                  dataCySuffix: "none",
                },
                resultToReRoll: {
                  title: "Single result",
                  key: "single",
                  applications: [
                    "damage",
                    "hitRoll",
                    "invulnSaveRoll",
                    "saveRoll",
                    "woundRoll",
                  ],
                  dataCySuffix: "single",
                },
                valueRange: [],
                valueSingle: "1",
              },
            },
            scope: ["profile"],
            id: "579866db-3f6c-45a2-b055-6836465a5fe6",
            sharedWithAllUnits: false,
          },
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "Re-roll all possible failed hit rolls (if attacker)",
            effect: {
              text: "Re-roll",
              type: "reRoll",
              data: {
                application: {
                  title: "Hit roll",
                  key: "hitRoll",
                },
                limit: {
                  title: "No limit",
                  key: "none",
                  dataCySuffix: "none",
                },
                resultToReRoll: {
                  title: "All possible failures",
                  key: "allPossibleFailures",
                  applications: [
                    "hitRoll",
                    "invulnSaveRoll",
                    "saveRoll",
                    "woundRoll",
                  ],
                  dataCySuffix: "all-possible-failures",
                },
                valueRange: [],
                valueSingle: null,
              },
            },
            scope: ["profile"],
            id: "4c10f321-9427-4603-9345-53191e351ceb",
            sharedWithAllUnits: true,
          },
        ],
        id: "fb3795c1-7f0c-40a9-a1dc-26af2535799f",
        leader: false,
        name: "Breachers",
        points: null,
        model_types: [
          {
            id: "a9b5bf92-8396-419d-a9ba-0a72f111a31d",
            ignore: null,
            invuln: 6,
            keywords: ["INFANTRY"],
            modelCount: 3,
            name: "Breacher",
            save: 3,
            toughness: 7,
            weapons: [
              {
                name: "Hydraulic claw",
                countPerUnit: 1,
                type: "Melee",
                attacks: 2,
                ws: 4,
                strength: 8,
                ap: -2,
                damage: 3,
                id: "db022623-6c8a-4a0f-95e5-968204937e19",
                nameUnique: "Hydraulic claw",
                abilities: [],
              },
              {
                name: "Heavy arc rifle",
                countPerUnit: 3,
                type: "Ranged",
                attacks: 2,
                bs: 4,
                strength: 8,
                ap: -2,
                damage: 3,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Anti-VEHICLE 4+",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Keywords (only)",
                        type: "keywordsOnly",
                        data: {
                          keywords: ["VEHICLE"],
                        },
                        description: "Require one or more keywords.",
                        preselected: false,
                      },
                      {
                        text: "Attack step roll",
                        type: "attackStepRoll",
                        data: {
                          attackStep: {
                            title: "Wound roll",
                            key: "woundRoll",
                          },
                          rollReq: {
                            title: "Specific roll",
                            key: "specificRoll",
                          },
                          rollState: {
                            title: "Unmodified",
                            key: "unmodified",
                          },
                          rollTarget: {
                            title: "Or greater",
                            key: "orGreater",
                          },
                          rollValue: "4",
                        },
                        description:
                          "Require a specific roll value in the attack sequence.",
                        preselected: false,
                      },
                    ],
                    description:
                      "Wound roll of 4+ (unmodified) : critical wound (VEHICLE only)",
                    effect: {
                      text: "Override requirements",
                      type: "overrideReqs",
                      data: {
                        crit: true,
                        irrespective: false,
                        outcome: {
                          title: "Wound",
                          key: "wound",
                        },
                        type: {
                          title: "Always",
                          key: "always",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "0281c608-cf74-4640-b8e7-1554bdcb399c",
                    sharedWithAllUnits: false,
                  },
                  {
                    aliases: [
                      {
                        name: "Rapid fire 2",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Range",
                        type: "range",
                        data: {
                          range: {
                            title: "Within half range",
                            key: "withinHalfRange",
                          },
                        },
                        description: "Check attack range.",
                        preselected: false,
                      },
                    ],
                    description: "Increase attacks by 2 (within half range)",
                    effect: {
                      text: "Increase weapon attacks",
                      type: "increaseWeaponAttacks",
                      data: {
                        increaseWeaponAttacksValue: "2",
                        applyToExtraAttacks: false,
                      },
                    },
                    scope: ["weapon"],
                    id: "73d6fd1b-f7a7-4f5f-9cc0-203c56d6b8e6",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "ff358933-f56a-4de0-ab33-45fad979bcdc",
                nameUnique: "Heavy arc rifle",
              },
            ],
            wounds: 3,
          },
        ],
        abilities_selected: ["579866db-3f6c-45a2-b055-6836465a5fe6"],
      },
      {
        abilities: [
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Defender",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "Feel no pain 5+",
            effect: {
              text: "Feel no pain",
              type: "feelNoPain",
              data: {
                value: "5",
              },
            },
            scope: ["profile"],
            id: "544c6fca-cedc-4a86-9584-8cba2598107f",
            sharedWithAllUnits: true,
          },
        ],
        id: "7345281b-cec3-478a-9ac6-dd6d8a602f52",
        leader: true,
        name: "Dominus",
        points: null,
        model_types: [
          {
            id: "ed84838f-defd-4338-b67d-4b8fd57bf261",
            ignore: null,
            invuln: 5,
            keywords: ["INFANTRY", "CHARACTER"],
            modelCount: 1,
            name: "Dominus",
            save: 2,
            toughness: 4,
            weapons: [
              {
                name: "Omnissian axe",
                countPerUnit: 1,
                type: "Melee",
                attacks: 4,
                ws: 3,
                strength: 6,
                ap: -2,
                damage: 2,
                id: "3bdc38fb-ede8-43cf-97de-5b59596adda3",
                nameUnique: "Omnissian axe",
                abilities: [],
              },
              {
                name: "Macrostubber",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 5,
                bs: 3,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "3b758741-b66f-47e4-b84e-31444cf21b5f",
                nameUnique: "Macrostubber",
                abilities: [],
              },
              {
                name: "Volkite blaster",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 3,
                bs: 3,
                strength: 5,
                ap: 0,
                damage: 2,
                abilities: [
                  {
                    aliases: [
                      {
                        name: "Devastating wounds",
                        type: "reserved",
                      },
                    ],
                    aliasActive: true,
                    conditions: [
                      {
                        text: "Critical hit/wound",
                        type: "crit",
                        data: {
                          crit: {
                            title: "Critical wound",
                            key: "woundRoll",
                          },
                        },
                        description: 'Require a hit or wound to be "critical".',
                        preselected: false,
                        scope: ["global", "profile", "weapon"],
                      },
                    ],
                    description: "Critical wound : disable save (inc. invuln)",
                    effect: {
                      text: "Disable mechanic",
                      type: "disableAbility",
                      data: {
                        option: {
                          title: "Disable save (inc. invuln)",
                          key: "disableSave",
                        },
                      },
                    },
                    scope: ["weapon"],
                    id: "c8e913aa-44f9-4311-8f97-b8df9adffa25",
                    sharedWithAllUnits: false,
                  },
                ],
                id: "f76430bc-a75c-4d1b-ad7b-be7bf755cabe",
                nameUnique: "Volkite blaster",
              },
            ],
            wounds: 4,
          },
        ],
        abilities_selected: ["544c6fca-cedc-4a86-9584-8cba2598107f"],
      },
    ],
    weapons_selected_melee: [
      "db022623-6c8a-4a0f-95e5-968204937e19",
      "3bdc38fb-ede8-43cf-97de-5b59596adda3",
    ],
    weapons_selected_ranged: [
      "ff358933-f56a-4de0-ab33-45fad979bcdc",
      "3b758741-b66f-47e4-b84e-31444cf21b5f",
      "f76430bc-a75c-4d1b-ad7b-be7bf755cabe",
    ],
  },
  {
    name: "Advanced attacker with shared & unshared abilities",
    computed_keywords: [],
    computed_leaders: [
      {
        unitId: 1,
        unitName: "Leader unit",
      },
    ],
    computed_model_count: 7,
    computed_points: 0,
    computed_roles: ["Attacker: Ranged", "Defender"],
    computed_toughness: 4,
    computed_wounds: 16,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "6ab5140f-a14a-42d2-9045-d57c26cdfb89",
        modelTypeName: "Grunt model type",
        unitId: "e364b42a-7fca-4c9f-b072-6570f881e2fb",
      },
      {
        modelTypeId: "ac670d2f-e48d-46d3-9005-3ef88b69691c",
        modelTypeName: "Leader model type",
        unitId: "1b69e41a-6daa-4923-b68d-213f1a5fa11a",
      },
    ],
    units: [
      {
        abilities: [
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "+1 to wound roll (if attacker)",
            effect: {
              text: "Modify (relative)",
              type: "modifyRelative",
              data: {
                application: {
                  title: "Wound roll",
                  key: "woundRoll",
                },
                operator: {
                  title: "Add",
                  key: "add",
                },
                relativeValue: "1",
              },
            },
            id: "8f2e73e5-7f6b-468b-9cfb-14c34b975d00",
            scope: ["profile"],
            sharedWithAllUnits: false,
            updated: 1719855292765,
          },
        ],
        id: "e364b42a-7fca-4c9f-b072-6570f881e2fb",
        leader: false,
        name: "Grunt unit",
        points: null,
        model_types: [
          {
            id: "6ab5140f-a14a-42d2-9045-d57c26cdfb89",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: 6,
            name: "Grunt model type",
            save: 4,
            toughness: 4,
            weapons: [
              {
                name: "Grunt gun",
                nameUnique: "Grunt gun",
                countPerUnit: 6,
                type: "Ranged",
                attacks: 2,
                bs: 4,
                strength: 4,
                ap: 0,
                damage: 2,
                updated: 1719856287678,
                id: "16c5d430-c306-4d21-a131-50d3f605084a",
                computed: {
                  modelTypeId: 2,
                  unitId: 2,
                },
                abilities: [],
              },
            ],
            wounds: 2,
          },
        ],
        abilities_selected: [],
      },
      {
        abilities: [
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "Re-roll all possible failed hit rolls (if attacker)",
            effect: {
              text: "Re-roll",
              type: "reRoll",
              data: {
                application: {
                  title: "Hit roll",
                  key: "hitRoll",
                },
                limit: {
                  title: "No limit",
                  key: "none",
                  dataCySuffix: "none",
                },
                resultToReRoll: {
                  title: "All possible failures",
                  key: "allPossibleFailures",
                  applications: [
                    "hitRoll",
                    "invulnSaveRoll",
                    "saveRoll",
                    "woundRoll",
                  ],
                  dataCySuffix: "all-possible-failures",
                },
                valueRange: [],
                valueSingle: null,
              },
            },
            scope: ["profile"],
            sharedWithAllUnits: true,
            id: "b98e1a5c-3ad2-46bd-b2ce-76c8608df2ee",
            updated: 1719855087644,
          },
        ],
        id: "1b69e41a-6daa-4923-b68d-213f1a5fa11a",
        leader: true,
        name: "Leader unit",
        points: null,
        model_types: [
          {
            id: "ac670d2f-e48d-46d3-9005-3ef88b69691c",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: 1,
            name: "Leader model type",
            save: 4,
            toughness: 4,
            weapons: [
              {
                name: "Leader gun",
                nameUnique: "Leader gun",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 12,
                bs: 4,
                strength: 4,
                ap: 0,
                damage: 2,
                updated: 1719856295505,
                id: "87db7c1a-6801-442e-a178-05ed49f2dd86",
                computed: {
                  modelTypeId: 1,
                  unitId: 1,
                },
                abilities: [],
              },
            ],
            wounds: 4,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [
      "16c5d430-c306-4d21-a131-50d3f605084a",
      "87db7c1a-6801-442e-a178-05ed49f2dd86",
    ],
  },
  {
    name: "Advanced defender with shared & unshared abilities",
    computed_keywords: [],
    computed_leaders: [
      {
        unitId: 1,
        unitName: "Leader unit",
      },
    ],
    computed_model_count: 4,
    computed_points: 0,
    computed_roles: ["Defender"],
    computed_toughness: 4,
    computed_wounds: 8,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "eeafe418-2e36-4618-8f92-b5075685b7a9",
        modelTypeName: "Grunt model type",
        unitId: "041b6bce-d881-4c87-a562-a89dfcf6f713",
      },
      {
        modelTypeId: "3b717656-baa6-47e7-ae7e-4caf653f2664",
        modelTypeName: "Leader model type",
        unitId: "00fb6178-9dec-443b-b1df-8f5afb2c3af3",
      },
    ],
    units: [
      {
        abilities: [
          {
            description: "Degrade AP by 3 (if defender)",
            scope: ["profile"],
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: false,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            aliases: [],
            effect: {
              data: {
                application: {
                  title: "AP",
                  key: "ap",
                },
                operator: {
                  title: "Degrade by",
                  key: "degrade",
                },
                relativeValue: "3",
              },
              text: "Modify (relative)",
              type: "modifyRelative",
            },
            aliasActive: true,
            sharedWithAllUnits: false,
            id: "84d51128-6df3-4a4b-bdfb-dc98c5e29923",
            updated: 1720109150634,
          },
        ],
        id: "041b6bce-d881-4c87-a562-a89dfcf6f713",
        leader: false,
        name: "Grunt unit",
        points: null,
        model_types: [
          {
            id: "eeafe418-2e36-4618-8f92-b5075685b7a9",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: 2,
            name: "Grunt model type",
            save: 4,
            toughness: 4,
            weapons: [],
            wounds: 2,
          },
        ],
        abilities_selected: [],
      },
      {
        abilities: [
          {
            description: "-1 to damage (if defender)",
            scope: ["profile"],
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: false,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            aliases: [],
            effect: {
              data: {
                application: {
                  title: "Damage",
                  key: "damage",
                },
                operator: {
                  title: "Subtract",
                  key: "subtract",
                },
                relativeValue: "1",
              },
              text: "Modify (relative)",
              type: "modifyRelative",
            },
            aliasActive: true,
            sharedWithAllUnits: true,
            id: "2978c6e0-74f8-490a-859b-762446675723",
            updated: 1720109036837,
          },
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Defender",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
                scope: ["global", "profile", "weapon"],
              },
            ],
            description: "Degrade AP by 4 (if defender)",
            effect: {
              text: "Modify (relative)",
              type: "modifyRelative",
              data: {
                application: {
                  title: "AP",
                  key: "ap",
                },
                operator: {
                  title: "Degrade by",
                  key: "degrade",
                },
                relativeValue: "4",
              },
            },
            id: "bcf0fe15-8510-4b11-a4a3-72e5743f4420",
            scope: ["profile"],
            sharedWithAllUnits: true,
            updated: 1720116997851,
          },
        ],
        id: "00fb6178-9dec-443b-b1df-8f5afb2c3af3",
        leader: true,
        name: "Leader unit",
        points: null,
        model_types: [
          {
            id: "3b717656-baa6-47e7-ae7e-4caf653f2664",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: 2,
            name: "Leader model type",
            save: 4,
            toughness: 4,
            weapons: [],
            wounds: 2,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: [],
  },
  {
    name: "Multiple attacker abilities & multiple defender abilities",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 4,
    computed_points: 0,
    computed_roles: ["Attacker: Ranged", "Defender"],
    computed_toughness: 4,
    computed_wounds: 16,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "7e0d87a1-2bd2-45b5-828e-693ca22eab95",
        modelTypeName:
          "Multiple attacker abilities & multiple defender abilities",
        unitId: "24ff4a5b-fa07-442f-a634-ce012ea441a6",
      },
    ],
    units: [
      {
        abilities: [
          {
            description: "+1 to armour save roll (if defender)",
            scope: ["profile"],
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: false,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            aliases: [],
            effect: {
              data: {
                application: {
                  title: "Armour save roll",
                  key: "armourSaveRoll",
                },
                operator: {
                  title: "Add",
                  key: "add",
                },
                relativeValue: 1,
              },
              text: "Modify (relative)",
              type: "modifyRelative",
            },
            aliasActive: true,
            sharedWithAllUnits: false,
            id: "8a72abf9-319a-497e-864d-d118903cfe59",
          },
          {
            description: "-1 to damage (if defender)",
            scope: ["profile"],
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: false,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            aliases: [],
            effect: {
              data: {
                application: {
                  title: "Damage",
                  key: "damage",
                },
                operator: {
                  title: "Subtract",
                  key: "subtract",
                },
                relativeValue: 1,
              },
              text: "Modify (relative)",
              type: "modifyRelative",
            },
            aliasActive: true,
            sharedWithAllUnits: false,
            id: "787676b0-6d1d-4bea-9dbd-ff97d9e92d0a",
          },
          {
            aliases: [
              {
                name: "Lethal hits",
                type: "reserved",
              },
            ],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
              {
                text: "Critical hit/wound",
                type: "crit",
                data: {
                  crit: {
                    title: "Critical hit",
                    key: "hitRoll",
                  },
                },
                description: 'Require a hit or wound to be "critical".',
                preselected: false,
              },
            ],
            description: "Critical hit : always wound (if attacker)",
            effect: {
              text: "Override requirements",
              type: "overrideReqs",
              data: {
                crit: false,
                irrespective: false,
                outcome: {
                  title: "Wound",
                  key: "wound",
                },
                type: {
                  title: "Always",
                  key: "always",
                },
              },
            },
            scope: ["profile"],
            sharedWithAllUnits: false,
            id: "f661fd71-eefb-45ec-a8ef-b812943d524a",
          },
          {
            aliases: [],
            aliasActive: true,
            conditions: [
              {
                text: "Profile role",
                type: "profileRole",
                data: {
                  profileRole: "Attacker",
                },
                description:
                  "Require the current profile to be set as the attacker or defender.",
                preselected: true,
              },
              {
                text: "Critical hit/wound",
                type: "crit",
                data: {
                  crit: {
                    title: "Critical wound",
                    key: "woundRoll",
                  },
                },
                description: 'Require a hit or wound to be "critical".',
                preselected: false,
              },
            ],
            description: "Critical wound : improve AP by 1 (if attacker)",
            effect: {
              text: "Modify (relative)",
              type: "modifyRelative",
              data: {
                application: {
                  title: "AP",
                  key: "ap",
                },
                operator: {
                  title: "Improve by",
                  key: "improve",
                },
                relativeValue: "1",
              },
            },
            scope: ["profile"],
            sharedWithAllUnits: false,
            id: "18abb1a3-71cd-494c-84cf-749c5be9fd84",
          },
        ],
        id: "24ff4a5b-fa07-442f-a634-ce012ea441a6",
        leader: false,
        name: "Multiple attacker abilities & multiple defender abilities > Unit 1",
        points: null,
        model_types: [
          {
            id: "7e0d87a1-2bd2-45b5-828e-693ca22eab95",
            ignore: null,
            invuln: null,
            keywords: [],
            modelCount: 4,
            name: "Multiple attacker abilities & multiple defender abilities > Unit 1 > Model type 1",
            save: 4,
            toughness: 4,
            weapons: [
              {
                name: "Gun 1",
                countPerUnit: 1,
                type: "Ranged",
                attacks: 4,
                bs: 4,
                strength: 4,
                ap: 0,
                damage: 1,
                updated: 1720121201818,
                id: "a6aae654-0931-4290-8fea-b64f9938bf96",
                nameUnique: "Gun 1",
                computed: {
                  modelTypeId: 1,
                  unitId: 1,
                },
                abilities: [],
              },
            ],
            wounds: 4,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: [],
    weapons_selected_ranged: ["a6aae654-0931-4290-8fea-b64f9938bf96"],
  },
  {
    name: "Modify (absolute) profile abilities",
    computed_keywords: [],
    computed_leaders: [],
    computed_model_count: 1,
    computed_roles: ["Attacker: Melee", "Attacker: Ranged", "Defender"],
    computed_toughness: 4,
    computed_wounds: 1,
    order_slain_auto: true,
    order_slain_model_types: [
      {
        modelTypeId: "67d2db71-8ce0-4d9d-a961-1310a46b7d9a",
        modelTypeName: null,
        unitId: "50e1f147-6e42-4ec0-b798-ca283704ddef",
      },
    ],
    units: [
      {
        abilities: [
          {
            conditions: [
              {
                data: {
                  profileRole: "Attacker",
                },
                preselected: true,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            description: "Set BS to 3 (if attacker)",
            scope: ["profile"],
            id: "befd36ab-540c-4266-b1c2-47b3b616e485",
            effect: {
              data: {
                application: {
                  title: "BS",
                  key: "bs",
                },
                operator: {
                  title: "Replace",
                  key: "replace",
                },
                absoluteValue: "3",
              },
              text: "Modify (absolute)",
              type: "modifyAbsolute",
            },
            aliases: [],
            aliasActive: true,
            sharedWithAllUnits: false,
          },
          {
            conditions: [
              {
                data: {
                  profileRole: "Attacker",
                },
                preselected: true,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            description: "Set WS to 3 (if attacker)",
            scope: ["profile"],
            id: "a97d7355-3b55-47fc-b89f-47e89668349b",
            effect: {
              data: {
                application: {
                  title: "WS",
                  key: "ws",
                },
                operator: {
                  title: "Replace",
                  key: "replace",
                },
                absoluteValue: "3",
              },
              text: "Modify (absolute)",
              type: "modifyAbsolute",
            },
            aliases: [],
            aliasActive: true,
            sharedWithAllUnits: false,
          },
          {
            conditions: [
              {
                data: {
                  profileRole: "Defender",
                },
                preselected: true,
                text: "Profile role",
                type: "profileRole",
              },
            ],
            description: "Set save roll to 2 (if defender)",
            scope: ["profile"],
            id: "8abefdb8-8c0f-4307-bb47-43bba24c1008",
            effect: {
              data: {
                application: {
                  title: "Save roll",
                  key: "saveRoll",
                },
                operator: {
                  title: "Replace",
                  key: "replace",
                },
                absoluteValue: "2",
              },
              text: "Modify (absolute)",
              type: "modifyAbsolute",
            },
            aliases: [],
            aliasActive: true,
            sharedWithAllUnits: false,
          },
        ],
        id: "50e1f147-6e42-4ec0-b798-ca283704ddef",
        leader: false,
        name: "Modify (absolute) profile abilities > Unit 1",
        points: null,
        model_types: [
          {
            modelCount: 1,
            save: 3,
            toughness: 4,
            weapons: [
              {
                name: "Bolter",
                countPerUnit: "1",
                type: "Ranged",
                attacks: 10,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "8ab67864-3fb7-44c2-8955-6f0aac501e6c",
                bs: 4,
                ws: null,
                nameUnique: "Bolter",
                abilities: [],
              },
              {
                name: "Close combat weapon",
                type: "Melee",
                attacks: 10,
                strength: 4,
                ap: 0,
                damage: 1,
                id: "3ca7701e-e286-4a0c-9c8e-4827406f1552",
                countPerUnit: 1,
                bs: null,
                ws: 4,
                nameUnique: "Close combat weapon",
                abilities: [],
              },
            ],
            wounds: 1,
            id: "67d2db71-8ce0-4d9d-a961-1310a46b7d9a",
            name: "Modify (absolute) profile abilities > Unit 1 > Model type 1",
            ignore: null,
            invuln: null,
          },
        ],
        abilities_selected: [],
      },
    ],
    weapons_selected_melee: ["3ca7701e-e286-4a0c-9c8e-4827406f1552"],
    weapons_selected_ranged: ["8ab67864-3fb7-44c2-8955-6f0aac501e6c"],
  },
]
